import type { UnsyncedOrder } from '../../../../types/api.types';

export const ERROR_TYPE_OPTIONS = ['NEGATIVE_STOCK_ERROR', 'DUPLICATE_ORDER'] as const;
export type ErrorTypeOption = (typeof ERROR_TYPE_OPTIONS)[number];

export const ERROR_TYPE_LABELS: Record<ErrorTypeOption, string> = {
    NEGATIVE_STOCK_ERROR: 'Negative stock error',
    DUPLICATE_ORDER: 'Duplicate order',
};

const NETWORK_STATUS_BADGE: Record<string, { label: string; badge: string }> = {
    OFFLINE: {
        label: 'Offline',
        badge: 'bg-[#fffbeb] border-[#fde68a] text-[#92400e]',
    },
    ONLINE: {
        label: 'Online',
        badge: 'bg-[#f0fdf4] border-[#bbf7d0] text-[#15803d]',
    },
};

export function formatPrice(price: number): string {
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0,
    }).format(price);
}

export function formatDateTime(dateStr: string): string {
    try {
        return new Date(dateStr).toLocaleString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
        });
    } catch {
        return dateStr;
    }
}

export function formatErrorType(errorType: string | null | undefined): string | null {
    if (!errorType) return null;
    return ERROR_TYPE_LABELS[errorType as ErrorTypeOption] ?? errorType;
}

export function getNetworkBadge(status: string | null | undefined) {
    if (!status) return null;
    const normalized = status.toUpperCase();
    return (
        NETWORK_STATUS_BADGE[normalized] ?? {
            label: status,
            badge: 'bg-[#f8fafc] border-[#e2e8f0] text-[#64748b]',
        }
    );
}

export function getOrderHeaderId(order: UnsyncedOrder): string {
    return order.offlineOrderID || order.orderID;
}

export function getOrderItemCount(order: UnsyncedOrder): number {
    return order.items?.length ?? 0;
}

export function getOrderItemsTotal(order: UnsyncedOrder): number {
    return (order.items ?? []).reduce((sum, item) => sum + (item.price ?? 0), 0);
}
